import { render, staticRenderFns } from "./TopDetail.vue?vue&type=template&id=4f4b42b0&functional=true&"
import script from "./TopDetail.vue?vue&type=script&lang=ts&"
export * from "./TopDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports